import Confetti from "react-confetti";
import styled from "styled-components";
import { Tooltip } from "react-tooltip";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import coinsIcon from "assets/img/icons/coins-icon.svg";
import bulbIcon from "assets/img/icons/tip-bulb.svg";
import streakIcon from "assets/img/icons/flash-icon-indigo.svg";

const Reward = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
`;

const RewardNote = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const RewardBox = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  gap: 30px;

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const RewardIconCircle = styled.div`
  width: 150px;
  min-width: 150px;
  height: 150px;

  border-radius: 50%;
  background: ${css.FLAT_BOX_BACKGROUND};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const RewardIcon = styled.div`
  width: 70px;
  min-width: 70px;
  height: 70px;
`;

const RewardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const RewardTitle = styled.div`
  font-size: 36px;
  font-weight: 500;
  text-align: center;
`;

const RewardSubTitle = styled.div`
  color: ${css.BRAND_GREEN};
  text-align: center;
`;

const RewardNoteIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const RewardNoteText = styled.div`
  font-size: 13px;
`;

const StreakBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
    gap: 6px;
  }

  &:hover {
    cursor: help;
  }
`;

const StreakPercentBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
`;

const StreakIcon = styled.div`
  width: 22px;
  min-width: 22px;
  height: 22px;
`;

const StreakPercent = styled.div`
  font-weight: 700;
`;

const StreakText = styled.div`
  text-align: center;
`;

const StreakGreenText = styled.span`
  color: ${css.BRAND_GREEN};
`;

export default ({ reward, streak }) => {
  let streakBonus = Math.round(reward * (streak / 100));

  if (streakBonus < 1) streakBonus = 1;
  if (streakBonus > 100) streakBonus = 100;

  const plural = streakBonus > 1 ? "s" : "";

  return (
    <Reward>
      <RewardNote />
      <RewardBox>
        <RewardIconCircle>
          <RewardIcon>
            <img src={coinsIcon} alr="Reward" style={{ width: "100%" }} />
          </RewardIcon>
        </RewardIconCircle>
        <RewardContent>
          <RewardTitle>You found coins!</RewardTitle>
          <RewardSubTitle>
            {reward} coins have been added to your wallet
          </RewardSubTitle>
        </RewardContent>
      </RewardBox>
      {streak > 0 && (
        <>
          <StreakBox
            data-tooltip-id="streakBonus"
            data-tooltip-html="For each day you find coins, your Activity Streak Bonus increases by one percentage point.<br><br>If you miss a day, your bonus resets back to 0%, and you'll start over.<br><br><a href='https://help.scalelup.com/en/articles/11320560-activity-streak-bonus' target='_blank' class='tooltip-link'>Learn more</a>"
            data-tooltip-place="top"
            data-tooltip-delay-show={500}
            onClick={(e) => e.stopPropagation()}
          >
            <StreakPercentBox>
              <StreakIcon>
                <img
                  src={streakIcon}
                  alr="Streak Bonus"
                  style={{ width: "100%" }}
                />
              </StreakIcon>
              <StreakPercent>+{streak}%</StreakPercent>
            </StreakPercentBox>
            <StreakText>
              You have received{" "}
              <StreakGreenText>
                {streakBonus} additional coin{plural}
              </StreakGreenText>{" "}
              as an Activity Streak bonus
            </StreakText>
          </StreakBox>
          <Tooltip id="streakBonus" className="tooltip" clickable />
        </>
      )}
      <RewardNote>
        <RewardNoteIcon>
          <img src={bulbIcon} alt="Tip" style={{ width: "100%" }} />
        </RewardNoteIcon>
        <RewardNoteText>
          Continue browsing to get even more coins.
        </RewardNoteText>
      </RewardNote>
      <Confetti />
    </Reward>
  );
};
